export const formatEinNumber = (number: string) => {
  const match = number.match(/^(\d{2})(\d{7})$/);

  if (match) {
    return match[1] + "-" + match[2];
  }

  return null;
};
